module.exports = __webpack_public_path__ + "static/media/circular_checkmark.839d0082.svg";